export default "__VITE_ASSET__Bs7fccqQ__"